import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { errorToast } from 'Common/ToastHelper';

import {
  getTaxGroupSetup,
  taxGroupSetupDelete,
  taxGroupSetupInsertUpdate,
  clearTaxGroupSetupData,
} from './state/actions';

import TaxGroupSetupComponent from './components/TaxGroupSetupComponent';
import { TaxGroupSetupFieldEnum as Fields } from 'Common/FieldEnum';
import { NotificationMessage } from 'Components';

class TaxGroupSetupContainer extends Component {
  state = {
    open: false,
    rowData: {
      Id: 0,
      RefNum: '',
      Description: '',
      State: 0.0,
      County: 0.0,
      Local: 0.0,
    },
    size: 'mini',
    isValid: false,
    showDeleteModal: false,
  };

  componentDidMount() {
    this.props.getTaxGroupSetup();
  }

  componentWillUnmount() {
    this.props.clearTaxGroupSetupData();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.idleTimeUTC !== this.props.idleTimeUTC) {
      return false;
    }

    return true;
  }

  componentDidUpdate(prevProps) {
    errorToast(this.props, prevProps, 'taxGroupSetupError');
  }

  close = () => this.setState({ open: false });

  deleteTaxGroupSetup = row => {
    this.setState({
      rowData: {
        Id: row.Id,
        RefNum: row.ReferenceId,
        Description: row.Description,
        State: row.State,
        County: row.County,
        Local: row.Local,
      },
      showDeleteModal: true,
    });
  };

  editTaxGroupSetup = row => {
    this.setState({
      rowData: {
        Id: row.Id,
        RefNum: row.RefNum,
        Description: row.Description,
        State: !row.State ? '0.00' : row.State.toFixed(2),
        County: !row.County ? '0.00' : row.County.toFixed(2),
        Local: !row.Local ? '0.00' : row.Local.toFixed(2),
      },
      open: true,
      isValid: true,
    });
  };

  addTaxGroupSetup = () => {
    this.setState({
      rowData: {
        Id: 0,
        RefNum: '',
        Description: '',
        State: null,
        County: null,
        Local: null,
      },
      open: true,
      isValid: false,
    });
  };

  handleSubmit = values => {
    const { taxGroupSetupInsertUpdate } = this.props;
    const { rowData } = this.state;

    const data = {
      Id: values[Fields.Id],
      RefNum: values[Fields.ReferenceId],
      Description: _.trim(values[Fields.Description]),
      State: values[Fields.State],
      County: values[Fields.County],
      Local: values[Fields.Local],
      IsNew: rowData.Id ? false : true,
    };

    taxGroupSetupInsertUpdate(data).then(result => {
      NotificationMessage(result);
      this.setState({ open: false });
    });
  };

  setIsValid = isValid => {
    this.setState({ isValid });
  };

  handleDialog = result => {
    if (result) {
      const { taxGroupSetupDelete } = this.props;
      taxGroupSetupDelete(this.state.rowData.Id).then(result => {
        NotificationMessage(result);
      });
    }

    this.setState({ showDeleteModal: false });
  };
  clearFilters = () => {
    this.setState({ filtered: [] });
  };
  onFilteredChange = filtered => {
    this.setState({ filtered });
  };

  render() {
    const {
      open,
      dimmer,
      size,
      rowData,
      isValid,
      showDeleteModal,
    } = this.state;
    const { taxGroupSetupData, loading, isReadOnly } = this.props;

    return (
      <TaxGroupSetupComponent
        open={open}
        dimmer={dimmer}
        size={size}
        rowData={rowData}
        isValid={isValid}
        loading={loading}
        showDeleteModal={showDeleteModal}
        taxGroupSetupData={taxGroupSetupData}
        sortById={true}
        addTaxGroupSetup={this.addTaxGroupSetup}
        editTaxGroupSetup={this.editTaxGroupSetup}
        deleteTaxGroupSetup={this.deleteTaxGroupSetup}
        handleDialog={this.handleDialog}
        handleSubmit={this.handleSubmit}
        setIsValid={this.setIsValid}
        close={this.close}
        filtered={this.state.filtered}
        onFilteredChange={this.onFilteredChange}
        clearFilters={this.clearFilters}
        isReadOnly={isReadOnly}
      />
    );
  }
}

const mapStateToProps = ({ TaxGroupSetupState }) => {
  return {
    taxGroupSetupData: TaxGroupSetupState.taxGroupSetupData,
    taxGroupSetupError: TaxGroupSetupState.taxGroupSetupError,
    loading: TaxGroupSetupState.loading,
  };
};

export const TaxGroupSetup = connect(
  mapStateToProps,
  {
    getTaxGroupSetup,
    taxGroupSetupDelete,
    taxGroupSetupInsertUpdate,
    clearTaxGroupSetupData,
  }
)(TaxGroupSetupContainer);



// WEBPACK FOOTER //
// ./src/pages/inventory/taxgroupsetup/TaxGroupSetup.js